import { render, staticRenderFns } from "./MaSvgRf.vue?vue&type=template&id=2581409c&scoped=true"
import script from "./MaSvgRf.vue?vue&type=script&lang=js"
export * from "./MaSvgRf.vue?vue&type=script&lang=js"
import style0 from "./MaSvgRf.vue?vue&type=style&index=0&id=2581409c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2581409c",
  null
  
)

export default component.exports